import Form from './components/Form';
import './App.css';

const App = () => <Form />;

export default App;
